import { CategoryEnum } from "../types/categorias.type";
var licenseService = {
    id: 0,
    title: CategoryEnum.HABILITACAO,
    tags: [
        "Consulta de Documentos",
        "Emissão de Taxas",
        "Abertura de Solicitações",
    ],
    services: [
        {
            category: CategoryEnum.HABILITACAO,
            title: "Consultar CNH do Condutor",
            subtitle: "Veja todos os dados da Carteira Nacional de Habilitação.",
            goTo: "/habilitacao/consulta-cnh",
        },
        {
            category: CategoryEnum.HABILITACAO,
            title: "Consulta e Emissão de Taxas da CNH",
            subtitle: "Consulte e emita as taxas referentes a CNH do Condutor.",
            goTo: "/habilitacao/emitir-taxas",
        },
        {
            category: CategoryEnum.HABILITACAO,
            title: "Solicitar Renovação de CNH",
            subtitle: "Realize a Solicitação da Renovação da CNH.",
            goTo: "/habilitacao/renovacao-cnh",
            isRequestService: true,
        },
        {
            category: CategoryEnum.HABILITACAO,
            title: "Solicitar troca da CNH temporária para CNH definitiva",
            subtitle: "Realize a Solicitação de um novo processo de CNH definitiva.",
            goTo: "/habilitacao/cnh-definitiva",
            isRequestService: true,
        },
        {
            category: CategoryEnum.HABILITACAO,
            title: "Solicitar Segunda Via da CNH",
            subtitle: "Realize a Solicitação de um novo processo de segunda via de CNH.",
            goTo: "/habilitacao/segundo-via",
            isRequestService: true,
        },
        {
            category: CategoryEnum.HABILITACAO,
            title: "Solicitar Abertura do Processo PID (Carteira Internacional)",
            subtitle: "Realize a Solicitação da Carteira Internacional.",
            goTo: "/habilitacao/processo-pid",
            isRequestService: true,
        },
        {
            category: CategoryEnum.HABILITACAO,
            title: "Emitir Certidão de Condutor",
            subtitle: "Consulte, emita ou remova certidões do condutor.",
            goTo: "/habilitacao/certidao-condutor",
            isRequestService: true,
        },
    ],
};
var vehicleService = {
    id: 1,
    title: CategoryEnum.VEICULOS,
    tags: [
        "Consulta de Veículos",
        "Emissão de Documentação",
        "Consulta de Débitos",
    ],
    services: [
        {
            category: CategoryEnum.VEICULOS,
            title: "Consulta e Emissão de Taxas do Veículo",
            subtitle: "Veja todas as taxas que encontram-se em aberto para o Veículo.",
            goTo: "/veiculos/consulta-licenciamentos",
        },
        {
            category: CategoryEnum.VEICULOS,
            title: "Emitir IPVA",
            subtitle: "Realize a Emissão do IPVA do Veículo.",
            goTo: "/veiculos/consulta-ipva",
        },
        {
            category: CategoryEnum.VEICULOS,
            title: "Emitir CRLVe",
            subtitle: "Realize a Emissão do Certificado de Registro e Licenciamento de Veículo.",
            goTo: "/veiculos/consulta-crlve",
        },
        {
            category: CategoryEnum.VEICULOS,
            title: "Emitir Certidão de Baixa",
            subtitle: "Realize a Emissão do Certificado de Baixa Definitiva de Veículo.",
            goTo: "/veiculos/certidao-baixa",
        },
        {
            category: CategoryEnum.VEICULOS,
            title: "Emitir Certidão de Propriedade",
            subtitle: "Realize a Emissão do Certificado de Propriedade de Veículo.",
            goTo: "/veiculos/certidao-propriedade",
        },
        {
            category: CategoryEnum.VEICULOS,
            title: "Inclusão de GRAVAME",
            subtitle: "Solicitar inclusão de GRAVAME ao veículo.",
            goTo: "/veiculos/inclusao-gravame",
        },
    ],
};
var infractionService = {
    id: 2,
    title: CategoryEnum.INFRACOES,
    tags: ["Consulta de Infrações", "Consulta de Pontos"],
    services: [
        {
            category: CategoryEnum.INFRACOES,
            title: "Consultar Infrações em Aberto",
            subtitle: "Veja todas as infrações que encontram-se em aberto.",
            goTo: "/veiculos/infracoes",
        },
        {
            category: CategoryEnum.INFRACOES,
            title: "Consultar Pontos do Condutor",
            subtitle: "Veja a pontuação do condutor logado.",
            goTo: "/infracoes/consulta-pontos",
        },
    ],
};
export var allCategories = [
    licenseService,
    vehicleService,
    infractionService,
];
